import { combineReducers } from 'redux';

import {
    DEALS_LOADING,
    DEALS_LOADED,
    DEAL_LOADED,
    DEAL_LOADING,
} from 'modules/deals/actions/deal.action';
import { AUTH_LOGOUT } from 'modules/auth/actions/authentication.action';

export const loadingDeals = (state = false, action) => {
    switch (action.type) {
        case DEALS_LOADING:
            return action.payload;
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const deals = (state = null, action) => {
    switch (action.type) {
        case DEALS_LOADED:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

export const loadingDeal = (state = false, action) => {
    switch (action.type) {
        case DEAL_LOADING:
            return action.payload;
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const deal = (state = null, action) => {
    switch (action.type) {
        case DEAL_LOADED:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

export default combineReducers({
    loadingDeals,
    deals,
    loadingDeal,
    deal,
});
